import { render, staticRenderFns } from "./InsurancesAndfund.vue?vue&type=template&id=4693a9aa&scoped=true&"
import script from "./InsurancesAndfund.vue?vue&type=script&lang=js&"
export * from "./InsurancesAndfund.vue?vue&type=script&lang=js&"
import style0 from "./InsurancesAndfund.vue?vue&type=style&index=0&id=4693a9aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4693a9aa",
  null
  
)

export default component.exports